import { useQuery } from "@tanstack/react-query";
import { ThreadMessages } from "api/schema/insights/threads";
import { AxiosError } from "axios";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

export const threadMessagesKeys = {
  allThreads: ["getMessagesForThread"],
  one: ({ companyId, threadId }: { companyId: string; threadId: string }) => [
    ...threadMessagesKeys.allThreads,
    { companyId, threadId },
  ],
};

export const useGetThreadMessages = ({
  companyId,
  threadId = "",
}: {
  companyId: string;
  threadId: string;
}) => {
  const publicApi = usePublicApiService();

  return useQuery<ThreadMessages, AxiosError>({
    staleTime: 30 * 60_000,
    enabled: !!threadId && !!companyId,
    queryKey: threadMessagesKeys.one({ companyId, threadId }),
    queryFn: () =>
      publicApi.getInsightsThreadMessages({
        companyId,
        threadId,
      }),
  });
};
